import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-slate-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <img 
              className="h-12 w-auto mb-6" 
              src="img/gpax.png" 
              alt="GPAX" 
            />
            <a 
              href="https://wa.me/50624479912" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-line mr-2"></i>
              {t('footer.talk')}
            </a>
            <div className="flex space-x-4 mt-6">
              <a 
                href="https://www.linkedin.com/company/infoware-s-a-" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors cursor-pointer"
              >
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a 
                href="https://www.facebook.com/gpax.io" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors cursor-pointer"
              >
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a 
                href="mailto:soluciones@infowarecr.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors cursor-pointer"
              >
                <i className="ri-mail-fill text-xl"></i>
              </a>
              <a 
                href="https://www.instagram.com/infoware.cr/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors cursor-pointer"
              >
                <i className="ri-instagram-fill text-xl"></i>
              </a>
            </div>
          </div>

          <div className="text-center">
            <div className="space-y-2">
              <a 
                href="https://support.gpax.io/portal/es/kb/articles/terminos-de-servicio" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
              >
                {t('footer.terms')}
              </a>
              <span className="text-gray-500 mx-2">•</span>
              <a 
                href="https://support.gpax.io/portal/es/kb/articles/acuerdo-de-confidencialidad" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
              >
                {t('footer.privacy')}
              </a>
              <span className="text-gray-500 mx-2">•</span>
              <a 
                href="https://support.gpax.io/portal/es/kb/articles/acuerdo-de-nivel-de-servicio-sla" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
              >
                {t('footer.sla')}
              </a>
            </div>
          </div>

          <div className="text-right">
            <h3 className="text-xl font-bold mb-4">{t('footer.contact')}</h3>
            <div className="space-y-2 text-gray-400">
              <p>{t('footer.phone')}</p>
              <p>{t('footer.email')}</p>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; 2024 GPAX - Infoware. Todos los derechos reservados.</p>
          <p className="mt-2">
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-white transition-colors cursor-pointer whitespace-nowrap"
            >
              Powered by Readdy
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}